import { useState, useEffect } from 'react';
import { BaseUrl } from '../api';

const useCsrfToken = () => {
    const [csrfToken, setCsrfToken] = useState("");

    useEffect(() => {
        const getToken = async () => {
            try {
                const response = await fetch(`${BaseUrl}/token/`, {
                    method: "GET",
                    credentials: "include",
                });
                const data = await response.json();
                setCsrfToken(data.csrf_token);
            } catch (error) {
                console.log(error);
            }
        };
        getToken();
    }, [BaseUrl]);

    return { csrfToken };
};

export default useCsrfToken;
